export default "__VITE_ASSET__BeC05SOj__"